import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ModeEditRounded } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { AI_SEARCH_URL } from "../../../utils/routes";
import { usePostHog } from "posthog-js/react";
import { CLICK_NEW_SESSION_BUTTON_ON_MESSAGE_PAGE } from "../../../utils/posthogEvents";
import { useThemeSettings } from "../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  newSessionBtn: {
    background: "#FDF0FF",
    border: "1px solid #E1BEE7",
    boxShadow: "none",
    color: "rgba(0, 0, 0, 0.87)",
    "& .MuiButton-icon": {
      color: "#7B1FA2",
    },
  },
}));

function Header() {
  const posthog = usePostHog();
  const history = useHistory();
  const { classes } = useStyles();
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";

  const handleClickNewSession = () => {
    posthog.capture(CLICK_NEW_SESSION_BUTTON_ON_MESSAGE_PAGE);
    history.push(AI_SEARCH_URL);
  };

  return (
    <Box
      height={64}
      p={2}
      gap={2}
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}>
      <Typography variant="h6">Search</Typography>
      <Button
        variant="contained"
        color="primary"
        className={isDarkMode ? null : classes.newSessionBtn}
        startIcon={<ModeEditRounded />}
        sx={{ minWidth: 151, textTransform: "capitalize" }}
        onClick={handleClickNewSession}>
        New Session
      </Button>
    </Box>
  );
}

export default Header;
